import React, { useEffect, useMemo, useRef, useState } from 'react';

export default function ArtistEventGenreBadgeRotator({ all }) {
  const [idx, setIdx] = useState(0);
  const [fading, setFading] = useState(false);
  const holdTimerRef = useRef(null);
  const fadeTimerRef = useRef(null);

  const idsKey = useMemo(
    () => (Array.isArray(all) ? all.map((g) => g?.id).join(',') : ''),
    [all]
  );

  useEffect(() => { setIdx(0); }, [idsKey]);

  useEffect(() => {
    if (!all || all.length <= 1) return undefined;

    const clearTimers = () => {
      if (holdTimerRef.current) clearTimeout(holdTimerRef.current);
      if (fadeTimerRef.current) clearTimeout(fadeTimerRef.current);
      holdTimerRef.current = null;
      fadeTimerRef.current = null;
    };
    clearTimers();

    const prefersReduce =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const scheduleNext = () => {
      holdTimerRef.current = setTimeout(() => {
        if (prefersReduce) {
          setIdx((p) => (p + 1) % all.length);
          scheduleNext();
          return;
        }
        setFading(true);
        fadeTimerRef.current = setTimeout(() => {
          setIdx((p) => (p + 1) % all.length);
          setFading(false);
          scheduleNext();
        }, 300);
      }, 2800);
    };

    scheduleNext();
    return () => clearTimers();
  }, [all, idsKey]);

  const g = all?.[idx];
  if (!g) return null;

  return (
    <p
      className={`genre ${fading ? 'is-fading' : ''}`}
      style={{
        backgroundColor: g.color || 'var(--contract-detail-action-blue)',
        color: g.text_color || 'var(--color-inverse)',
      }}
    >
      {g.label}
    </p>
  );
}
